(() => {
    if (window.ctProCarouselV624) return;
    window.ctProCarouselV624 = true;
    const initRoot = (root) => {
    if (!root || root.dataset.proCarouselReady) return;
    root.dataset.proCarouselReady = 'true';
    const SVG_MUTE = '<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73 4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>';
    const SVG_SOUND = '<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>';
    const track = root.querySelector('.ct-pro-track-v624');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 767px)');
    const connection = navigator.connection;
    const autoplay = root.dataset.proAutoplay === 'true';
    const abort = new AbortController();
    const on = (target, name, fn) => target.addEventListener(name, fn, { signal: abort.signal });
    let ready = false;
    let destroyed = false;
    let nearObserver;
    let viewObserver;
    let posterObserver;
    // Stock PDP posters keep their image; materialize when the carousel is within 600px.
    const posters = Array.from(root.querySelectorAll('img.pro-poster[data-pro-poster-src]'));
    // Only the four stock PDPs that rendered deferred posters opt into navigation sizing.
    const navigationScope = posters.length > 0;
    const navigationButtons = navigationScope
      ? Array.from(root.querySelectorAll('[data-pro-direction]'), (button) => ({ button, hidden: button.hidden }))
      : [];
    let navigationPostersReady = false;
    let navigationStarted = false;
    let navigationFrame = null;
    let navigationUpdating = false;
    let navigationResizeObserver;
    const focusVisibleVideoControl = () => {
      for (const button of root.querySelectorAll('[data-pro-toggle]')) {
        if (!button.isConnected || button.disabled || button.getAttribute('aria-disabled') === 'true') continue;
        let visible = true;
        for (let element = button; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) {
            visible = false;
            break;
          }
        }
        if (!visible) continue;
        const rect = button.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0 || rect.left < 0 || rect.right > innerWidth || rect.top < 0 || rect.bottom > innerHeight) continue;
        const hit = document.elementFromPoint(rect.left + rect.width / 2, rect.top + rect.height / 2);
        if (hit !== button && !button.contains(hit)) continue;
        try { button.focus({ preventScroll: true }); }
        catch { try { button.focus(); } catch { /* Keep the focused arrow if focus cannot move safely. */ } }
        if (document.activeElement === button) return true;
      }
      return false;
    };
    const updateNavigation = () => {
      const width = track.clientWidth;
      if (width <= 0) return;
      const noOverflow = track.scrollWidth <= width + 1;
      const active = document.activeElement;
      const focused = noOverflow && navigationButtons.find(({ button }) => button === active || button.contains(active));
      // Never hide an active arrow before another visible, owned control has focus.
      const keepFocused = focused && !focusVisibleVideoControl();
      navigationButtons.forEach(({ button, hidden }) => {
        if (keepFocused && button === focused.button) return;
        const nextHidden = noOverflow ? true : hidden;
        if (button.hidden !== nextHidden) button.hidden = nextHidden;
      });
    };
    const queueNavigationUpdate = () => {
      if (destroyed || !ready || !navigationScope || !track || !navigationPostersReady || navigationFrame !== null || navigationUpdating) return;
      navigationFrame = window.requestAnimationFrame(() => {
        navigationFrame = null;
        if (destroyed) return;
        navigationUpdating = true;
        try { updateNavigation(); }
        finally { navigationUpdating = false; }
      });
    };
    const startNavigation = () => {
      if (!navigationScope || !track || navigationStarted) return;
      navigationStarted = true;
      if ('ResizeObserver' in window) {
        navigationResizeObserver = new ResizeObserver(queueNavigationUpdate);
        navigationResizeObserver.observe(track);
        if (states[0]?.card) navigationResizeObserver.observe(states[0].card);
      }
      on(window, 'resize', queueNavigationUpdate);
      on(window, 'pageshow', queueNavigationUpdate);
      navigationButtons.forEach(({ button }) => on(button, 'blur', queueNavigationUpdate));
      queueNavigationUpdate();
    };
    const destroyNavigation = () => {
      navigationResizeObserver?.disconnect();
      if (navigationFrame !== null) window.cancelAnimationFrame(navigationFrame);
      navigationFrame = null;
      navigationButtons.forEach(({ button, hidden }) => { if (button.hidden !== hidden) button.hidden = hidden; });
    };
    const showPosters = () => {
      if (destroyed) return;
      posters.forEach((img) => {
        if (!img.dataset.proPosterSrc) return;
        if (img.dataset.proPosterSrcset) img.srcset = img.dataset.proPosterSrcset;
        img.src = img.dataset.proPosterSrc;
        delete img.dataset.proPosterSrc;
        delete img.dataset.proPosterSrcset;
      });
      navigationPostersReady = true;
      queueNavigationUpdate();
    };
    if (posters.length) {
      if ('IntersectionObserver' in window) {
        posterObserver = new IntersectionObserver((entries) => {
          if (destroyed || !entries.some((entry) => entry.isIntersecting)) return;
          posterObserver.disconnect();
          showPosters();
        }, { rootMargin: '600px 0px' });
        posterObserver.observe(root);
      } else {
        showPosters();
      }
    }
    const states = Array.from(root.querySelectorAll('.smart-video'), (video) => ({
      video, card: video.parentElement, near: false, ratio: 0, manual: false,
      userPaused: false, blocked: false, pending: false, token: 0, frame: null
    }));
    const restricted = () => motion.matches || Boolean(connection && connection.saveData);
    const eligible = (s) => ready && s.near && s.ratio >= 0.6 && !document.hidden && !destroyed;
    const wanted = (s) => !s.userPaused && !s.blocked && (s.manual || (autoplay && !restricted()));
    const loader = (s, visible) => s.card.querySelector('.pro-loader').classList.toggle('is-visible', visible);
    const sync = (s) => {
      const playing = !s.video.paused;
      s.card.querySelector('[data-pro-toggle]').setAttribute('aria-pressed', String(playing));
      const indicator = s.card.querySelector('.pro-indicator');
      // Badge only when autoplay will not happen on its own (user pause, restricted, blocked).
      const autoplayPending = autoplay && !restricted() && !s.userPaused && !s.blocked;
      indicator.hidden = playing || s.pending || autoplayPending;
      indicator.textContent = s.blocked ? 'Reintentar ▶' : '▶';
    };
    const pause = (s) => {
      s.allowed = false;
      s.token++;
      s.pending = false;
      if (s.frame !== null && s.video.cancelVideoFrameCallback) s.video.cancelVideoFrameCallback(s.frame);
      s.frame = null;
      s.video.pause();
      loader(s, false);
      sync(s);
    };
    const play = (s) => {
      // Every source assignment passes BOTH gates; clicks cannot bypass them.
      if (!eligible(s) || !wanted(s) || s.pending || !s.video.paused) return;
      s.allowed = true;
      if (mobile.matches) document.dispatchEvent(new CustomEvent('pro-carousel:mobile-play', { detail: s.video }));
      const token = ++s.token;
      s.pending = true;
      loader(s, true);
      sync(s);
      if (!s.video.hasAttribute('src')) {
        s.video.src = s.video.dataset.videoSrc;
        s.video.load();
      }
      const failed = () => {
        if (token !== s.token || destroyed) return;
        s.pending = false;
        s.blocked = true;
        loader(s, false);
        sync(s);
        if (s.manual) s.card.querySelector('[data-pro-status]').textContent = 'No se pudo reproducir. Tocá el video para reintentar.';
      };
      const promise = s.video.play();
      if (promise) promise.then(() => {
        if (token !== s.token) return;
        s.pending = false;
        if (!eligible(s) || !wanted(s)) pause(s);
        else sync(s);
      }).catch(failed);
    };
    const reconcile = () => {
      const candidates = states.filter((s) => eligible(s) && wanted(s));
      // Keep a current player on equal visibility to avoid churn between cards.
      candidates.sort((a, b) => Number(b.manual) - Number(a.manual) || b.ratio - a.ratio || Number(a.video.paused) - Number(b.video.paused));
      const allowed = mobile.matches ? candidates.slice(0, 1) : candidates;
      states.forEach((s) => { if (!allowed.includes(s)) pause(s); });
      allowed.forEach(play);
    };
    states.forEach((s) => {
      const video = s.video;
      video.muted = true;
      const toggle = () => {
        if (s.pending || !video.paused || s.manual) {
          s.manual = false;
          s.userPaused = true;
          pause(s);
        } else {
          s.manual = true;
          s.userPaused = false;
          s.blocked = false;
          s.card.querySelector('[data-pro-status]').textContent = '';
          // Prefer the card explicitly selected on mobile, even if another is wider.
          if (mobile.matches) states.forEach((other) => { if (other !== s) { other.manual = false; pause(other); } });
          play(s);
        }
      };
      // Native button covers the video without a visible play button.
      // Enter/Space and pointer activation share the browser's native behavior.
      on(s.card.querySelector('[data-pro-toggle]'), 'click', toggle);
      on(video, 'playing', () => {
        if (!s.allowed || !eligible(s) || !wanted(s)) { pause(s); return; }
        s.pending = false;
        const reveal = () => {
          s.frame = null;
          if (video.paused || !eligible(s)) return;
          const poster = s.card.querySelector('.pro-poster');
          if (poster) poster.hidden = true;
          loader(s, false);
          sync(s);
        };
        if (video.requestVideoFrameCallback) s.frame = video.requestVideoFrameCallback(reveal);
        else reveal();
      });
      on(video, 'pause', () => { loader(s, false); sync(s); });
      on(video, 'waiting', () => { if (eligible(s) && wanted(s)) loader(s, true); });
      on(video, 'error', () => {
        pause(s);
        s.blocked = true;
        s.manual = false;
        const poster = s.card.querySelector('.pro-poster');
        if (poster) poster.hidden = false;
        // Remove a failed URL so the next explicit tap can load it afresh.
        video.removeAttribute('src');
        video.load();
        s.card.querySelector('[data-pro-status]').textContent = 'Video no disponible. Tocá para reintentar.';
        sync(s);
      });
      const mute = s.card.querySelector('[data-pro-mute]');
      on(mute, 'click', () => { video.muted = !video.muted; });
      on(video, 'volumechange', () => {
        mute.setAttribute('aria-pressed', String(!video.muted));
        mute.setAttribute('aria-label', video.muted ? 'Activar sonido del video' : 'Silenciar video');
        mute.querySelector('svg').innerHTML = video.muted ? SVG_MUTE : SVG_SOUND;
      });
    });
    on(root, 'click', (event) => {
      const button = event.target.closest('[data-pro-direction]');
      const first = states[0];
      if (!button || !first) return;
      track.scrollBy({ left: (first.card.clientWidth + (Number(root.dataset.proGap) || 0)) * Number(button.dataset.proDirection), behavior: motion.matches ? 'auto' : 'smooth' });
    });
    on(document, 'pro-carousel:mobile-play', (event) => {
      states.forEach((s) => { if (s.video !== event.detail) { s.manual = false; pause(s); } });
    });
    on(document, 'visibilitychange', () => {
      if (document.hidden) states.forEach((s) => { s.manual = false; pause(s); });
      else reconcile();
    });
    const preferenceChanged = () => {
      if (restricted()) states.forEach((s) => { s.manual = false; pause(s); });
      reconcile();
    };
    on(motion, 'change', preferenceChanged);
    on(mobile, 'change', reconcile);
    if (connection) on(connection, 'change', preferenceChanged);
    on(window, 'pagehide', () => states.forEach(pause));
    on(window, 'pageshow', reconcile);
    const start = () => {
      if (destroyed) return;
      ready = true;
      startNavigation();
      if (!('IntersectionObserver' in window)) {
        states.forEach((s) => { s.card.querySelector('[data-pro-status]').textContent = 'La reproducción requiere un navegador con IntersectionObserver.'; });
        return;
      }
      nearObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const s = states.find((item) => item.video === entry.target);
          s.near = entry.isIntersecting;
        });
        reconcile();
      }, { rootMargin: '180px 0px', threshold: 0 });
      viewObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const s = states.find((item) => item.video === entry.target);
          s.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
          if (s.ratio < 0.6) s.manual = false;
        });
        reconcile();
      }, { threshold: [0, 0.6, 0.75, 0.9, 1] });
      states.forEach((s) => { nearObserver.observe(s.video); viewObserver.observe(s.video); });
    };
    on(document, 'shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      destroyed = true;
      destroyNavigation();
      posterObserver?.disconnect();
      nearObserver?.disconnect();
      viewObserver?.disconnect();
      states.forEach((s) => { pause(s); s.video.removeAttribute('src'); s.video.load(); });
      abort.abort();
      delete root.dataset.proCarouselReady;
    });
    // Never attach a source before the entire page finishes loading.
    // After load, wait for an idle slot so observers never compete with LCP work.
    const startWhenIdle = () => {
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 });
      else window.setTimeout(start, 120);
    };
    if (document.readyState === 'complete') startWhenIdle();
    else on(window, 'load', startWhenIdle);
  };
    const init = (scope) => {
      if (scope.matches?.('[data-ct-pro-carousel]')) initRoot(scope);
      scope.querySelectorAll('[data-ct-pro-carousel]').forEach(initRoot);
    };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    init(document);
  })();
